export default "__VITE_ASSET__CyLVZ7Sc__"